<div class="rp-dialog">
  <div class="rp-header">
    <div class="rp-header-main">
      <mat-icon class="rp-header-icon">{{ isEdit ? 'edit_calendar' : 'event' }}</mat-icon>
      <div class="rp-header-text">
        <h2 class="rp-title">{{ isEdit ? 'Einplanung bearbeiten' : 'Neue Einplanung' }}</h2>
        <div class="rp-subtitle" *ngIf="isSeries">
          <mat-icon>repeat</mat-icon> Teil einer Serie
        </div>
      </div>
    </div>
    <button mat-icon-button class="rp-close" (click)="cancel()" matTooltip="Schließen">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="rp-content">

    <!-- Wer & was -->
    <section class="rp-section">
      <div class="rp-section-head"><mat-icon>groups</mat-icon><span>Wer &amp; was</span></div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Mitarbeiter (verantwortlich)</mat-label>
        <mat-icon matPrefix class="ff-ic">person</mat-icon>
        <mat-select [(ngModel)]="assignedUserId">
          <mat-option *ngFor="let u of data.users" [value]="u.id">
            {{ u.name }}<span *ngIf="u.email"> ({{ u.email }})</span>
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Weitere Mitarbeiter (Team, optional)</mat-label>
        <mat-icon matPrefix class="ff-ic">group_add</mat-icon>
        <mat-select multiple [(ngModel)]="participantUserIds">
          <ng-container *ngFor="let u of data.users">
            <mat-option *ngIf="u.id !== assignedUserId" [value]="u.id">{{ u.name }}</mat-option>
          </ng-container>
        </mat-select>
      </mat-form-field>

      <div class="row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Titel</mat-label>
          <input matInput [(ngModel)]="title" maxlength="200" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Kategorie</mat-label>
          <mat-select [(ngModel)]="categoryId" (selectionChange)="onCategoryChange()">
            <mat-option *ngFor="let c of categories" [value]="c.id">
              <span class="cat-dot" [style.background]="c.color"></span>{{ c.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="rp-field-label">Status</div>
      <div class="status-pills">
        <button type="button" class="status-pill"
                *ngFor="let w of workStatuses"
                [class.active]="workStatus === w.value"
                [style.--pill]="w.color"
                (click)="workStatus = w.value">
          <span class="cat-dot" [style.background]="w.color"></span>{{ w.label }}
        </button>
      </div>
    </section>

    <!-- Wann -->
    <section class="rp-section">
      <div class="rp-section-head"><mat-icon>schedule</mat-icon><span>Wann</span></div>

      <div class="row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Beginn</mat-label>
          <input matInput type="datetime-local" [(ngModel)]="startLocal" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Ende</mat-label>
          <input matInput type="datetime-local" [(ngModel)]="endLocal" />
        </mat-form-field>
      </div>

      <div class="row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Reisezeit vorher (Min.)</mat-label>
          <mat-icon matPrefix class="ff-ic">directions_car</mat-icon>
          <input matInput type="number" min="0" max="600" [(ngModel)]="travelMinutesBefore" />
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Reisezeit nachher (Min.)</mat-label>
          <mat-icon matPrefix class="ff-ic">directions_car</mat-icon>
          <input matInput type="number" min="0" max="600" [(ngModel)]="travelMinutesAfter" />
        </mat-form-field>
      </div>

      <div class="row" *ngIf="!isEdit">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Wiederholung</mat-label>
          <mat-icon matPrefix class="ff-ic">repeat</mat-icon>
          <mat-select [(ngModel)]="repeatMode">
            <mat-option value="none">Keine</mat-option>
            <mat-option value="weekly">Wöchentlich</mat-option>
            <mat-option value="biweekly">Alle 2 Wochen</mat-option>
            <mat-option value="monthly">Monatlich</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width" *ngIf="repeatMode !== 'none'">
          <mat-label>Anzahl Termine</mat-label>
          <input matInput type="number" min="2" max="60" [(ngModel)]="repeatCount" />
        </mat-form-field>
      </div>
    </section>

    <!-- Wo & Bezug -->
    <section class="rp-section">
      <div class="rp-section-head"><mat-icon>place</mat-icon><span>Ort &amp; Bezug</span></div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Ort / Adresse</mat-label>
        <mat-icon matPrefix class="ff-ic">location_on</mat-icon>
        <input matInput [(ngModel)]="location" />
      </mat-form-field>

      <div class="row">
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Kunde (optional)</mat-label>
          <mat-select [(ngModel)]="customerId" (selectionChange)="onCustomerChange()">
            <mat-option [value]="null">— Kein Kunde —</mat-option>
            <mat-option *ngFor="let c of customers" [value]="c.id">{{ c.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="half-width">
          <mat-label>Anlage (optional)</mat-label>
          <mat-select [(ngModel)]="equipmentId" (selectionChange)="onEquipmentChange()"
                      [disabled]="!customerId || loadingEquipments">
            <mat-option [value]="null">— Keine Anlage —</mat-option>
            <mat-option *ngFor="let e of equipments" [value]="e.id">{{ e.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <mat-form-field appearance="outline" class="full-width" *ngIf="equipmentId">
        <mat-label>Wartungsauftrag (optional)</mat-label>
        <mat-icon matPrefix class="ff-ic">build</mat-icon>
        <mat-select [(ngModel)]="maintenanceId" (selectionChange)="onMaintenanceChange()">
          <mat-option [value]="null">— Kein Auftrag —</mat-option>
          <mat-option *ngFor="let m of maintenances" [value]="m.id">
            {{ m.title }}<span *ngIf="m.scheduledDate"> ({{ m.scheduledDate | date:'dd.MM.yyyy' }})</span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </section>

    <!-- Details -->
    <section class="rp-section">
      <div class="rp-section-head"><mat-icon>notes</mat-icon><span>Details</span></div>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Notizen</mat-label>
        <textarea matInput rows="3" [(ngModel)]="notes"></textarea>
      </mat-form-field>

      <div class="color-row">
        <span class="color-label">Farbe</span>
        <button type="button"
                *ngFor="let c of presetColors"
                class="color-dot"
                [style.background]="c"
                [class.selected]="color === c"
                (click)="pickColor(c)">
          <mat-icon *ngIf="color === c">check</mat-icon>
        </button>
      </div>
    </section>

    <label class="invite-toggle">
      <mat-checkbox [(ngModel)]="sendInvite" color="primary"></mat-checkbox>
      <mat-icon>mail</mat-icon>
      <span>Outlook-Termin per E-Mail an den Mitarbeiter senden</span>
    </label>
  </mat-dialog-content>

  <mat-dialog-actions class="rp-actions">
    <button mat-stroked-button color="warn" *ngIf="isEdit" (click)="delete()">
      <mat-icon>delete</mat-icon> Löschen
    </button>
    <span class="rp-spacer"></span>
    <button mat-stroked-button (click)="cancel()">Abbrechen</button>
    <button mat-flat-button color="primary" [disabled]="!isValid" (click)="save()">
      <mat-icon>check</mat-icon> Speichern
    </button>
  </mat-dialog-actions>
</div>
